import styled from "styled-components";
import { NewTypography, NewIcon, NewSelect } from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledWelcomeScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledTitle = styled(NewTypography)`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: ${(props) => (props.isMobile ? "22px" : "32px")};
  line-height: 29px;
  margin-bottom: ${(props) => (props.isMobile ? "1rem" : "3.5rem")};
`;

export const StyledGroupText = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.8125rem;
  margin-bottom: ${(props) => (props.isMobile ? "0.8125rem" : "1.875rem")};
`;

export const StyledText = styled(NewTypography)`
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.isMobile ? "14px" : "16px")};
  line-height: 29px;
  color: ${theme.color.text};
`;

export const StyledListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const StyledListElement = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.56rem;
`;

export const StyledListIcon = styled(NewIcon)``;

export const StyledListText = styled(StyledText)`
  font-weight: 600;
`;

export const StyledSingleText = styled(StyledText)`
  margin-bottom: ${(props) => (props.isMobile ? "0.5rem" : "0.8125rem")};

  &:last-of-type {
    margin-bottom: ${(props) => (props.isMobile ? "0.625rem" : "1.5rem")};
  }
`;

export const StyledCountryLabel = styled(StyledText)`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  margin-top: ${(props) => (props.isMobile ? "0.625rem" : "1.4375rem")};
  margin-bottom: ${(props) => (props.isMobile ? "0.8125rem" : "0.625rem")};
`;
export const StyledRequired = styled.span`
  color: ${theme.color.red};
  margin-left: 4px;
`;

export const StyledNewSelect = styled(NewSelect)``;
